export function getValue(list, value, name = 'name') {
  const nameValue = list.find((x) => x.node.id === value);
  return nameValue && nameValue.node[name];
}
